import { Flex } from "../../../../styled";
import { Divider, Text } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useSelector } from "../../../../redux/hooks";
import ConfirmationButton from "../../../../components/shared/ConfirmationButton/ConfirmationButton";
import { toMantineDateString } from "src/utils/mantineDates";

interface Props {
  date: string;
  children: React.ReactNode;
  onDateChange: (date: Date) => void;
  onDeleteItems: () => void;
  allDates: string[];
  disabled: boolean | undefined;
}
const VitalsInputWrapper = ({
  date,
  children,
  onDateChange,
  onDeleteItems,
  allDates,
  disabled,
}: Props) => {
  const { uppercase } = useSelector(state => state.preferencesSlice);
  const otherDates = allDates.filter(d => d !== date);
  const excludeDate = (dateString: string) => otherDates.includes(dateString);
  return (
    <Flex gap={5} direction="column">
      <Flex align="center" gap={5}>
        <Text style={{ fontWeight: 200 }}>Date:</Text>
        {disabled ? (
          <Text>{date}</Text>
        ) : (
          <DatePickerInput
            value={toMantineDateString(date)}
            styles={{
              input: { textTransform: uppercase ? "uppercase" : "none" },
            }}
            w={150}
            onChange={val => {
              if (val) onDateChange(new Date(`${val}T00:00:00`));
            }}
            excludeDate={excludeDate}
            valueFormat="DD MMM YYYY"
          />
        )}
        {!disabled && (
          <ConfirmationButton
            buttonProps={{
              color: "red",
              size: "xs",
              variant: "outline",
            }}
            modalText={`Are you sure you want to delete all records for ${date}?`}
            onConfirm={onDeleteItems}>
            Delete Records
          </ConfirmationButton>
        )}
      </Flex>
      {children}
      <Divider mt={10} />
    </Flex>
  );
};
export default VitalsInputWrapper;
